import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { Spin } from 'antd';
import { connect } from 'react-redux';
import { config } from '../../constant';
import clone from 'lodash.clonedeep';
import ReactEcharts from '../../Echarts/Echarts';
import AnomalyFeedbackTable from './AnomalyFeedbackTable';
import { trendLabelTranslation } from '../../../Utils/Adapter/translationAdapter';
import { getChartDataWithSelection, getChartDataWithoutSelection } from '../../ChartCalls';

const NotificationScatter = (props) => {

  const [option, setOption] = useState({});
  const [data, setData] = useState([]);
  const [loading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [feedbackForm, setFeedbackForm] = useState({});

  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());


  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData();
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear
  ]);


  const getData = async () => {
    let json = [];
    let series = [];
    let colors = [];
    let option = getOption();
    if (graphprops.colors && graphprops.colors.length > 0) {
      colors = graphprops.colors;
    } else {
      colors = ['rgb(251, 118, 123)', 'rgb(129, 227, 238)'];
    }
    if (
      graphprops &&
      ((graphprops.DashboardLevelSelection === 'datePicker' ||
        graphprops.GraphLevelSelection === 'datePicker') &&
        selectionDate) ||
      (
        (graphprops.DashboardLevelSelection === 'monthPicker' ||
          graphprops.GraphLevelSelection === 'monthPicker') &&
        selectionMonth) ||
      (
        (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
          graphprops.GraphLevelSelection === 'dateRangePicker') &&
        selectionDateRange) ||
      (
        (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
          graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
        dayMonthYear) ||
      (
        (graphprops.DashboardLevelSelection === 'deviceSelection' ||
          graphprops.GraphLevelSelection === 'deviceSelection') &&
        DeviceCode)
    ) {
      json = await getChartDataWithSelection({
        graphprops,
        selectionDate,
        selectionMonth,
        selectionDateRange,
        DeviceCode,
        dayMonthYear,
        abortController: abortController.current,
        currentTimeZone,
      });
      requestCheck.current = true;
    } else if (
      graphprops.GraphLevelSelection === 'none' ||
      graphprops.DashboardLevelSelection === 'none'
    ) {
      json = await getChartDataWithoutSelection({
        graphprops,
        abortController: abortController.current,
        DeviceCode,
        TimeZone: currentTimeZone,
      });
      requestCheck.current = true;
    }
    //  json =[
    //   {
    //     "scatter": [
    //       {
    //         "interval_alias": "2020-11-13 16:00:00",
    //         "tagname": "No 1 chip supply  Conveyor torque PV",
    //         "tagvalue": 10,
    //         "notification": {
    //           "Timestamp": "2020-11-13 10:30:00",
    //           "TagName": "TRR_TR121_PV",
    //           "Action": null,
    //           "Comment": null
    //         }
    //       }
    //     ]
    //   },
    //   {
    //     "scatter": [
    //       {
    //         "interval_alias": "2020-11-13 16:00:00",
    //         "tagname": "Chip supply feeder torque PV",
    //         "tagvalue": 26,
    //         "notification": {
    //           "Timestamp": "2020-11-13 16:00:00",
    //           "NotificationId": "TRR_TR131_PV_2020-11-14 01:00:00",
    //           "TagName": "TRR_TR131_PV",
    //           "TagDescription": "There are 26 spikes in back one hour",
    //           "Action": null,
    //           "Comment": null
    //         }
    //       },
    //       {
    //         "interval_alias": "2020-11-14 11:00:00",
    //         "tagname": "Chip supply feeder torque PV",
    //         "tagvalue": 38,
    //         "notification": {
    //           "Timestamp": "2020-11-14 11:00:00",
    //           "TagName": "TRR_TR131_PV",
    //           "Action": null,
    //           "Comment": null
    //         }
    //       }
    //     ]
    //   }
    // ]
    if (json && Array.isArray(json)) {
      json?.map((item, j) => {
        let xAxisDataArray = [];
        let name = [];
        item &&
          item?.scatter &&
          Array.isArray(item?.scatter) &&
          item?.scatter?.map((data) => {
            xAxisDataArray.push(
              moment
                .utc(data.interval_alias, 'YYYY-MM-DD HH:mm')
                .tz(props.currentTimeZone || 'UTC')
                .format('YYYY-MM-DD HH:mm')
            );
            name.push(data.tagname);
            return {};
          });

        let scatterObj = {
          name: name[0],
          symbolSize: 15,
          type: 'bar',
          color: colors[j],
          data:
            item &&
            item.scatter &&
            item.scatter.map(function (item) {
              return item.tagvalue;
            })
        };
        let effectScatterObj = {
          name: name[0],
          symbolSize: 15,
          type: 'bar',
          color: colors[j],
          data:
            item &&
            item.effectScatter &&
            item.effectScatter.map(function (item) {
              return item;
            })
        };
        series.push(scatterObj);
        series.push(effectScatterObj);
        let finalArray = xAxisDataArray.sort();

        option.xAxis.data = finalArray;
        return {};
      });
    }
    series = await trendLabelTranslation(series, props.translationCache, props.language);
    option.series = series;
    setOption(option);
    setData(json);
  };

  const onChartClick = (cellData) => {
    data &&
      data?.map((item) => {
        item?.scatter?.map((data) => {
          if (
            moment
              .utc(data.interval_alias)
              .tz(props.currentTimeZone || 'UTC')
              .format('YYYY-MM-DD HH:mm') === cellData.name &&
            data.tagvalue === cellData.value &&
            data.tagname === cellData.seriesName
          ) {
            let feedbackForm = clone(data.notification);
            setFeedbackForm(feedbackForm);
            setOpenModal(true);
          }
          return {};
        });
        return {};
      });
  };
  // const handleOk = () => {
  //   setOpenModal(false);
  // };

  // const handleCancel = () => {
  //   setOpenModal(false);
  // };



  let onEvents = {
    click: (cellData) => onChartClick(cellData)
  };

  const getOption = () => {
    let option = {
      tooltip: {
        formatter: function (param) {
          return [
            'Date ' + param.name + ': ',
            'value: ' + param.data,
            'Name: ' + param.seriesName
          ].join('<br/>');
        }
      },
      legend: {
        left: 'center',
        itemHeight: 17,
        itemWidth: 17,
        itemGap: 10.5,
        textStyle: {
          color: props.theme.algorithm === "dark" ? 'white' : 'black',
          fontWeight: 'bold',
          fontSize: 12
        }
      },
      xAxis: {
        type: 'category',
        splitLine: {
          lineStyle: {
            type: 'dashed'
          }
        },
        axisLine: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        },

        axisTick: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        },

        axisLabel: {
          color: props.theme.algorithm === "dark" ? 'white' : 'black',
          formatter: function (value) {
            return moment(value).format('HH:mm');
          }
        },
        scale: true
      },

      yAxis: {
        scale: true,

        // splitLine: {
        //     lineStyle: {
        //         type: 'dashed'
        //     }
        // },
        splitLine: {
          show: false
        },
        // scale: true,
        axisLine: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        },
        axisTick: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        },
        axisLabel: {
          color: props.theme.algorithm === "dark" ? 'white' : 'black'
        }
      },
      dataZoom: {
        type: 'slider'
      },

      series: [],
      toolbox: {
        showTitle: false,
        // orient: "vertical",
        itemSize: 25,
        feature: {
          saveAsImage: {
            // backgroundColor: "black",
            title: 'download',
            backgroundColor: props.theme.algorithm === "dark" ? 'black' : 'white',
            name: props.graphprops.title,
            iconStyle: {
              // color: "none",
              borderColor: '#8c8c8c',
              borderWidth: 2
            }
          }
        }
      }
    };
    return option;
  };
  return (
    <div style={{ height: '70%', marginTop: '40px' }}>
      {loading === false ? (
        <div style={{ padding: '10px' }}>
          <ReactEcharts
            onEvents={onEvents}
            option={option}
            className="react_for_echarts"
          />
          <AnomalyFeedbackTable
            feedbackForm={feedbackForm}
            openModal={openModal}
            // onOk={this.handleOk}
            // onCancel={this.handleCancel}
            refereshData={() => {
              getData();
            }}
          />
        </div>
      ) : (
     <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%'
              }}
            >
              <Spin spinning={loading} tip="Loading..." />
            </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone
  };
};

export default connect(mapStateToProps)(NotificationScatter);
